// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_'
})(this, function (m_module, Backbone, $, moment, _) {

  "use strict";


  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Challenge = M.Community.View.Challenge || {};

  M.Community.View.Challenge.ChallengesHomeApp = Backbone.View.extend({
    navigationSections: [{
      'sectionTitle': 'Challenges',
      'sectionId': '#challenges'
    }, {
      'sectionTitle': 'How it works',
      'sectionId': '#howItWorks'
    },{
      'sectionTitle': 'Why participate?',
      'sectionId': '#whyParticipate'
    }],

    initialize: function() {
      M.required(this.options.challenges);
      M.required(this.options.initialStateFilter);
      M.required(this.options.filterUrl);
      M.required(this.options.activityList);
      M.required(this.options.challengesCalendarIcsUrl);

      this._createChallengeGrid();
      this._createActivityFeedPanel();
      this._createPageNav();
      this._attachScrollHanders();
      this._createCalendarSubscriptionPopups();
    },

    _createChallengeGrid: function() {
      var challengeGrid = new M.Community.View.ChallengeGrid ({
        challenges: this.options.challenges,
        initialStateFilter: this.options.initialStateFilter,
        urlPaths: {
          filterUrl: this.options.filterUrl
        }
      });
      $('#challenges').append(challengeGrid.render().el);
      challengeGrid.filter(this.options.initialStateFilter);
      challengeGrid._renderToggle();
    },

    _createActivityFeedPanel: function() {
      new M.Community.View.Util.ActivityFeedPanel({
        activityList: this.options.activityList,
        $parentContainerEl: $('.activityFeedPanel')
      });
    },

    _createPageNav: function() {
      var navigationBar = new M.Community.View.Util.InPageNavigationBar ({
        inPageSections: this.navigationSections,
        $containerEl: $('.inPageNavigation'),
        shouldCreateStickyHeader: true
      });
    },

    _attachScrollHanders: function() {
      var challengeScrollTarget = $('#challenges').offset().top + $('.StickyNavHeader').innerHeight();
      $('#scrollToSection').click(function() {
        M.Community.View.Util.Common.scrollToSection(challengeScrollTarget);
      });
    },

    _createCalendarSubscriptionPopups: function() {
      var that = this;
      $('.challengeCalSubscribeButton').each(function() {
        var calendarDropdown = new M.Community.View.Calendar.SubscriptionPopup({
          subscribeButton: $(this),
          subscriptionLink: that.options.challengesCalendarIcsUrl
        });
        calendarDropdown.render();
      });
    }

  });

  return { };

});
